package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.image.ImageTarget
import fr.manyverse.app.domain.repository.ImageStorageRepository

class DeletePreMadeCharacterImageUseCase(
    private val imageStorageRepository: ImageStorageRepository
) {
    suspend operator fun invoke(tableId: String, preMadeId: String): Result<Unit> {
        return imageStorageRepository.delete(ImageTarget.PreMade(tableId, preMadeId))
    }
}
